import React from "react";
import AdSenseAd from "@/components/ads/AdSenseAd";

export default function PublicAdPlaceholder({ variant = "banner" }) {
  return <AdSenseAd placement={variant === "compact" ? "inArticle" : "display"} />;
}